import {
  GET_USER_DEFINITIONS_BY_GUID_SUCCESS,
  GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_SUCCESS,
  UPDATE_USER_DEFINITIONS_NEW_PASSWORD_SUCCESS,
  USER_DEFINITIONS_NEW_PASSWORD_API_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  error: {},
  record:"",
  waitingRecordListUpdate: false,
  waitingGetUserUpdate: false,
}

const UserDefinitionPassword = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_DEFINITIONS_BY_GUID_SUCCESS:
      return {
        ...state,
        record: action.payload,
        waitingGetUserUpdate: !state.waitingGetUserUpdate,
      }

    case GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL_SUCCESS:
      return {
        ...state,
        record: action.payload,
        waitingRecordListUpdate: !state.waitingRecordListUpdate,
      }

    case UPDATE_USER_DEFINITIONS_NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        record: action.payload,
        waitingRecordListUpdate: !state.waitingRecordListUpdate,
      }

    case USER_DEFINITIONS_NEW_PASSWORD_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:

      return state

  }
}

export default UserDefinitionPassword